import { ArrowRight } from 'lucide-react';

const WHATSAPP_URL = 'https://api.whatsapp.com/send?phone=5514998053885&text=Oi!%20Vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20um%20especialista';

const HeroSection = () => {
  const handleCTAClick = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'whatsapp_click', click_location: 'hero' });
    window.open(WHATSAPP_URL, '_blank');
  };

  return (
    <section
      className="hero-section relative min-h-screen flex items-center pt-20 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #111 0%, #1a1a1a 50%, #222 100%)' }}
    >
      {/* Background texture — subtle dot grid */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
        }}
      />

      {/* Accent glow behind photo */}
      <div
        className="absolute hidden lg:block"
        style={{
          width: '500px',
          height: '500px',
          right: '8%',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'radial-gradient(circle, rgba(245,134,52,0.08) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      <div className="hero-container container mx-auto px-4 py-12 md:py-20 relative z-10">
        <div className="hero-grid grid lg:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Left Content — order-2 on mobile so photo shows first */}
          <div className="space-y-6 md:space-y-8 order-2 lg:order-1">
            {/* Logo */}
            <img
              src="/images/logohorizontal.webp"
              alt="Way2Go"
              width="220"
              height="48"
              loading="eager"
              decoding="async"
              className="h-10 md:h-12 w-auto brightness-0 invert"
            />

            {/* Orange decorative bar */}
            <div className="w-16 h-1 bg-way2go-accent rounded-full" />

            {/* Headline */}
            <h1 className="hero-title text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
              <span className="text-white">Pare de gastar.</span>
              <br />
              <span className="text-way2go-accent">Comece a investir.</span>
            </h1>

            {/* Subheadline */}
            <p className="text-lg sm:text-xl md:text-2xl text-white/80 leading-relaxed max-w-xl">
              Transforme seu tráfego pago em vendas previsíveis com automação inteligente e IA que trabalha 24h por você.
            </p>

            {/* CTA */}
            <div>
              <button
                onClick={handleCTAClick}
                className="inline-flex items-center gap-3 bg-way2go-accent hover:bg-orange-600 text-white font-bold rounded-xl shadow-lg hover:shadow-way2go-accent/30 transition-all transform hover:scale-105"
                style={{ padding: '18px 36px', fontSize: '18px', minHeight: '56px' }}
                aria-label="Agendar sessão estratégica gratuita via WhatsApp"
              >
                Agendar Sessão Estratégica Grátis
                <ArrowRight className="w-5 h-5" />
              </button>
            </div>

            {/* Trust Indicators — 3-col grid on mobile, flex on desktop */}
            <div className="grid grid-cols-3 gap-4 sm:flex sm:flex-wrap sm:items-center sm:gap-8 pt-4 text-center sm:text-left">
              <div>
                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-white">500+</p>
                <p className="text-xs md:text-sm text-white/70">Campanhas Criadas</p>
              </div>
              <div>
                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-white">R$10M+</p>
                <p className="text-xs md:text-sm text-white/70">Investido em Tráfego</p>
              </div>
              <div>
                <p className="text-xl sm:text-2xl md:text-3xl font-bold text-white">95%</p>
                <p className="text-xs md:text-sm text-white/70">Taxa de Satisfação</p>
              </div>
            </div>
          </div>

          {/* Right Content — Photo first on mobile */}
          <div className="relative flex items-center justify-center order-1 lg:order-2">
            {/* Decorative geometric shape behind photo */}
            <div
              className="absolute"
              style={{
                width: '105%',
                height: '105%',
                top: '-2.5%',
                left: '2%',
                border: '3px solid rgba(245,134,52,0.3)',
                borderRadius: '2rem',
                transform: 'rotate(3deg)',
                pointerEvents: 'none',
              }}
            />
            <div
              className="absolute hidden md:block"
              style={{
                width: '105%',
                height: '105%',
                top: '2%',
                left: '-3%',
                border: '2px solid rgba(245,134,52,0.12)',
                borderRadius: '2rem',
                transform: 'rotate(-2deg)',
                pointerEvents: 'none',
              }}
            />

            {/* Photo container */}
            <div
              className="relative w-full overflow-hidden shadow-2xl"
              style={{ borderRadius: '2rem', aspectRatio: '4/5', maxWidth: '480px' }}
            >
              <picture>
                <source media="(max-width: 768px)" srcSet="/images/hero-team-mobile.webp" type="image/webp" />
                <source srcSet="/images/hero-team.webp" type="image/webp" />
                <img
                  src="/images/hero-team.webp"
                  alt="Equipe Way2Go Growth Marketing"
                  width="800"
                  height="1000"
                  fetchpriority="high"
                  loading="eager"
                  decoding="async"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: 'center 20%' }}
                />
              </picture>

              {/* Gradient overlay at bottom */}
              <div
                className="absolute inset-x-0 bottom-0 h-1/3"
                style={{ background: 'linear-gradient(to top, rgba(17,17,17,0.7), transparent)' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
